const {createArray, flatten1} = require("@Common/utils/collections");
const {paddingLeft}           = require("@Common/utils/strings");

const feed = [
    {
        "id": "12345",
        "type": "saturation",
        "mailingListName": "test 1",
        "count": "100",
        country: "US",
        "dateCreated": "Mon Sep 25 2019 10:32:05 GMT+0700 (Indochina Time)",
        failedCount: 10,

        "purchaseRequired": "0",
        // unitPrice: 0,
        listTypeId: 1,
        // warningCount: 2,

        locked: false,

    },
    {
        "id": "e234252",
        "type": "radius",
        "mailingListName": "test 2",
        "count": "100",
        country: "US",
        "dateCreated": "Mon Sep 23 2019 10:32:05 GMT+0700 (Indochina Time)",
        "purchaseRequired": "0",
        failedCount: 0,
        listTypeId: 2,
        unitPrice: 1,

        locked: true,
        // "purchaseRequired": "1",
        // unitPrice: 0,
        // listTypeId: 1,
    }
];
module.exports = flatten1(createArray(60).map((x) => (
    feed.map((f, i) => ({
        ...f,
        id: x * feed.length + i, // 0,1,2...
        "mailingListName": "Test ml " + paddingLeft(x * feed.length + i + 1),
    }))
)));

